var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alert-dialog',{attrs:{"centered":"","title":"Save Workout?","actions":[
    {
      title: 'No',
      callback: _vm.handleDismiss
    },
    {
      title: 'Yes, please!',
      callback: _vm.handleSignUp
    }
  ],"show":_vm.show},on:{"close":_vm.handleDismiss}},[_vm._v(" Save your workout history by creating an account ")])}
var staticRenderFns = []

export { render, staticRenderFns }